'use strict';

angular.module('amexReconciliationApp')
  .service('LineItemDetailsFieldDropdownModel', function (ModelFactory) {

    var model = ModelFactory.create('LineItemDetailsFieldDropdownModel', ['selectedField']);

    var fields = {
      'supplierPartNumber': 'supplierPartNumber',
      'unspscCode': 'unspscCode',
      'vendorName': 'vendorName',
      'costCenter': 'costCenter',
      'glAccount': 'glAccount',
      'locationCode': 'locationCode',
      'projectNumber': 'projectNumber',
      'trackingNumber': 'trackingNumber'
    };

    model.getFields = function () {
      return _.keys(fields);
    };

    model.getFieldValue = function (transaction) {
      return _.get(transaction, fields[model.selectedField()]);
    };

    model.selectedField('supplierPartNumber');

    return model;
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/LineItemDetailsFieldDropdownModel.js
// module id = 580
// module chunks = 0